module.exports = __webpack_public_path__ + "img/emil-pantelimon.def3f030.png";